import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Col, List, message, Row, Spin } from "antd";
import { Parse } from "parse";
import moment from "moment";

class BestTeam extends Component {
  constructor(props) {
    super(props);
    this.fidelity = Parse.User.current().attributes.team.attributes.ptsFidelity;
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    //query si user est pas pro
    this.currentUser = await Parse.User.current().fetch();
    this.queryBestTeam();
    let query = new Parse.Query("Fidelity");
    query.equalTo("team", this.currentUser.get("team"));
    query.include("team");
    query.include("user");
    query.include("coach");
    query.addDescending("createdAt");
    this.results = await query.find();
    this.setState({ loading: false });
  }

  //affichage d'un message en fonction du nombre de points de fidélité
  chooseHisto() {
    if (this.state.loading === true) {
      return (
        <p>
          {" "}
          <Spin />{" "}
        </p>
      );
    }
    return (
      <List
        itemLayout="horizontal"
        dataSource={this.results}
        pagination={{
          pageSize: 5,
          simple: true,
          hideOnSinglePage: true
        }}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={`${item.attributes.amount} points `}
              description={`${item.attributes.description} (obtenu le ${moment(
                item.createdAt
              ).format("DD MMMM YYYY")} par ${
                item.attributes.user.attributes.nickName
              })`}
            />
          </List.Item>
        )}
      />
    );
  }

  queryBestTeam = async () => {
    let teamId = this.currentUser.get("team").id;
    let query = new Parse.Query("Team");
    query.addDescending("ptsFidelity");
    this.teams = await query.find();
    this.ranking = this.teams.findIndex(item => item.id === teamId) + 1;
    this.classement = `${this.ranking} / ${this.teams.length} équipes`;
  };

  convertPoints = () => {
    let points = Parse.User.current().attributes.ptsFidelity;
    if (points < 5000)
      return message.error("Vous n'avez pas assez de points de fidélité !");
  };

  render() {
    return (
      <div>
        <Row type="flex">
          <Col
            span={12}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              paddingRight: "20px",
              paddingLeft: "20px"
            }}
          >
            <div style={{ textAlign: "center" }}>
              <span style={{ fontSize: "18px", color: "black" }}>
                Classement Best Team :{" "}
              </span>
              <span
                style={{
                  fontSize: "18px",
                  marginLeft: "18px",
                  color: "#0000FE"
                }}
              >
                {this.classement}
              </span>
            </div>

            <div style={{ textAlign: "center" }}>
              <span style={{ fontSize: "18px", color: "black" }}>
                Total de points :{" "}
              </span>
              <span
                style={{
                  fontSize: "18px",
                  marginLeft: "18px",
                  color: "#0000FE"
                }}
              >
                {this.fidelity} pts
              </span>
            </div>

            <Col style={{ textAlign: "center" }}>
              <Button
                style={{
                  backgroundColor: "#0000FE",
                  color: "white",
                  marginBottom: "15px",
                  marginTop: "15px"
                }}
                onClick={this.convertPoints}
              >
                {`Convertir en bon d'achat`}
              </Button>
            </Col>
            <Col style={{ marginTop: "30px" }}>
              <Col
                span={12}
                style={{
                  textAlign: "center",
                  color: "#0000FE",
                  fontSize: "18px"
                }}
              >
                <h3 style={{ color: "black", fontSize: "24px" }}>Points</h3>
                <p>5 000</p>
                <p>10 000</p>
                <p>15 000</p>
                <p>20 000</p>
                <p>50 000</p>
              </Col>
              <Col span={12} style={{ textAlign: "center", fontSize: "18px" }}>
                <h3 style={{ color: "black", fontSize: "24px" }}>Réduction</h3>
                <p>5 €</p>
                <p>10 €</p>
                <p>20 €</p>
                <p>30 €</p>
                <p>50 €</p>
              </Col>
            </Col>
          </Col>
          <Col
            span={12}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              paddingRight: "20px",
              paddingLeft: "20px"
            }}
          >
            <Col style={{ textAlign: "center" }}>
              <span style={{ fontSize: "24px", color: "black" }}>
                Historique de la Team
              </span>
              {this.chooseHisto()}
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedBestTeam = connect(
  mapStateToProps,
  null
)(BestTeam);
export default connectedBestTeam;
